// Destination countries ARMF delivers remittances to (send from AUD), matching
// the public armf.com send-money list. Selecting a country auto-derives the
// destination currency used for the AUD -> currency live rate. Flags are built
// from the ISO country code so there are no hand-typed emoji to drift.

export const SOURCE_CURRENCY = "AUD";

// [name, ISO 3166-1 alpha-2, ISO 4217 currency]
const RAW = [
  // Africa
  ["Benin", "BJ", "XOF"], ["Burkina Faso", "BF", "XOF"], ["Cameroon", "CM", "XAF"],
  ["Chad", "TD", "XAF"], ["Congo", "CG", "XAF"], ["Egypt", "EG", "EGP"],
  ["Ethiopia", "ET", "ETB"], ["Gabon", "GA", "XAF"], ["Ghana", "GH", "GHS"],
  ["Ivory Coast", "CI", "XOF"], ["Kenya", "KE", "KES"], ["Lesotho", "LS", "LSL"],
  ["Madagascar", "MG", "MGA"], ["Mali", "ML", "XOF"], ["Mayotte", "YT", "EUR"],
  ["Morocco", "MA", "MAD"], ["Mozambique", "MZ", "MZN"], ["Nigeria", "NG", "NGN"],
  ["Reunion", "RE", "EUR"], ["Rwanda", "RW", "RWF"], ["Senegal", "SN", "XOF"],
  ["Sierra Leone", "SL", "SLE"], ["Tanzania", "TZ", "TZS"], ["Togo", "TG", "XOF"],
  ["Tunisia", "TN", "TND"], ["Uganda", "UG", "UGX"],
  // Americas
  ["French Guiana", "GF", "EUR"],
  // Asia / Middle East
  ["Bahrain", "BH", "BHD"], ["Bangladesh", "BD", "BDT"], ["India", "IN", "INR"],
  ["Indonesia", "ID", "IDR"], ["Jordan", "JO", "JOD"], ["Kuwait", "KW", "KWD"],
  ["Malaysia", "MY", "MYR"], ["Nepal", "NP", "NPR"], ["Oman", "OM", "OMR"],
  ["Pakistan", "PK", "PKR"], ["Philippines", "PH", "PHP"], ["Qatar", "QA", "QAR"],
  ["Saudi Arabia", "SA", "SAR"], ["Singapore", "SG", "SGD"], ["Sri Lanka", "LK", "LKR"],
  ["Thailand", "TH", "THB"], ["United Arab Emirates", "AE", "AED"], ["Vietnam", "VN", "VND"],
  // Europe
  ["Austria", "AT", "EUR"], ["Belgium", "BE", "EUR"], ["Bulgaria", "BG", "EUR"],
  ["Croatia", "HR", "EUR"], ["Cyprus", "CY", "EUR"], ["Czechia", "CZ", "EUR"],
  ["Denmark", "DK", "EUR"], ["Estonia", "EE", "EUR"], ["Finland", "FI", "EUR"],
  ["France", "FR", "EUR"], ["Germany", "DE", "EUR"], ["Greece", "GR", "EUR"],
  ["Hungary", "HU", "EUR"], ["Iceland", "IS", "EUR"], ["Ireland", "IE", "EUR"],
  ["Italy", "IT", "EUR"], ["Latvia", "LV", "EUR"], ["Liechtenstein", "LI", "EUR"],
  ["Lithuania", "LT", "EUR"], ["Luxembourg", "LU", "EUR"], ["Malta", "MT", "EUR"],
  ["Netherlands", "NL", "EUR"], ["Norway", "NO", "EUR"], ["Poland", "PL", "EUR"],
  ["Portugal", "PT", "EUR"], ["Romania", "RO", "EUR"], ["Slovakia", "SK", "EUR"],
  ["Slovenia", "SI", "EUR"], ["Spain", "ES", "EUR"], ["Sweden", "SE", "EUR"],
  ["Turkey", "TR", "TRY"],
];

const flagFromIso = (iso) =>
  String.fromCodePoint(
    ...iso
      .toUpperCase()
      .split("")
      .map((ch) => 0x1f1e6 + ch.charCodeAt(0) - 65)
  );

export const DESTINATION_COUNTRIES = RAW.map(([name, iso, currency]) => ({
  name,
  iso,
  currency,
  flag: flagFromIso(iso),
})).sort((a, b) => a.name.localeCompare(b.name));

// Dropdown-ready options: value is the country ISO, label is "flag Name (CUR)".
export const DESTINATION_COUNTRY_OPTIONS = DESTINATION_COUNTRIES.map((c) => ({
  label: `${c.flag} ${c.name} (${c.currency})`,
  value: c.iso,
}));

const BY_ISO = Object.fromEntries(DESTINATION_COUNTRIES.map((c) => [c.iso, c]));

export const countryByIso = (iso) => BY_ISO[iso];
export const currencyForCountry = (iso) => BY_ISO[iso]?.currency;
